import React, { useState, useEffect } from 'react';
import Modal from '../../../../components/shareable/modal';
import { ChromePicker } from 'react-color';
import { FaEyeDropper } from 'react-icons/fa';

const CustomModal = ({ isOpen, onCancel, onConfirm, customType, title, message, confirmText = 'Confirm', showCancel = true }) => {
  const [customValue, setCustomValue] = useState('');
  const [color, setColor] = useState('#ffffff');
  const [showColorPicker, setShowColorPicker] = useState(false);
  const isColorPicker = customType === 'Conveyor Color';
  const isAlertModal = !customType && title && message;

  useEffect(() => {
    if (isOpen && !isAlertModal) {
      setCustomValue('');
      setColor('#ffffff');
      setShowColorPicker(false);
    }
  }, [isOpen, isAlertModal]);

  const handleColorChange = (newColor) => {
    const hexColor = newColor.hex;
    setColor(hexColor);
    setCustomValue(hexColor);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setCustomValue(value);
    
    // If input is a valid hex color, update the color state
    if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value)) {
      setColor(value);
    }
  };

  const handleConfirm = () => {
    if (isAlertModal) {
      onConfirm();
    } else if (customValue.trim()) {
      onConfirm(customValue.trim());
    }
  };

  const toggleColorPicker = () => { setShowColorPicker(!showColorPicker); };

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="p-2 max-w-md mx-auto bg-white rounded-lg">
        {isAlertModal ? (
          <>
            <h2 className="text-xl font-semibold text-gray-800 mb-4"> {title} </h2>
            <p className="text-gray-600 mb-6">{message}</p>
          </>
        ) : (
          <>
            <h2 className="text-xl font-semibold text-gray-800 mb-4"> Add A Custom {customType} </h2>
            
            <div className="mb-6">
              <div className="flex items-center">
                {isColorPicker && (
                  <div className="flex items-center mr-2">
                    <div className="w-8 h-8 rounded-md border border-gray-300" style={{ backgroundColor: color }} />
                  </div>
                )}
                <input
                  type="text"
                  className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder={isColorPicker ? `Enter color name (e.g., red) or hex code` : `Enter ${customType}`}
                  value={customValue}
                  onChange={handleInputChange}
                />
                {isColorPicker && (
                  <button type="button" onClick={toggleColorPicker} className="inline-flex items-center ml-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-red-500" >
                    <FaEyeDropper className="h-4 w-4" />
                  </button>
                )}
              </div>
            </div>

            {isColorPicker && showColorPicker && (
              <div className="mb-6 flex justify-center">
                <ChromePicker color={color} onChange={handleColorChange} disableAlpha={true} className="shadow-lg" />
              </div>
            )}
          </>
        )}
        
        <div className="flex justify-end space-x-3">
          {showCancel && (
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" onClick={onCancel} > Cancel </button>
          )}
          <button 
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
            onClick={handleConfirm}
            disabled={!isAlertModal && !customValue.trim()}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;